/* eslint-disable max-len */
import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'catalogos/dato-de-pago-del-empleado';

/**
 * GET Datos De Pago De Empleados
 * @returns {Promise<object[]>}
 */
export const getDatosDePagoDeEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Dato De Pago Del Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDatoDePagoDelEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Dato De Pago Del Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDatoDePagoDelEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    // onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Dato De Pago Del Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDatoDePagoDelEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    // onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Dato De Pago Del Empleado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDatoDePagoDelEmpleado = async (id) => {
  try {
    // eslint-disable-next-line no-unused-vars
    const response = await API.delete(`${baseURI}/${id}`);
    // onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Dato De Pago Del Empleado, para guardado masivo
 * se puede enviar un array de objetos o individual.
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const putDatoDePagoDelEmpleado = async (values) => {
  try {
    const response = await API.put(baseURI, values);
    // onSuccess(response, values.length === 1 ? 'Desactivado correctamente.' : 'Desactivados correctamente.');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
